import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n from '@/services/i18n/i18n';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';

export function WatcherLanguageFromBrowserToSettings() {
  const { is_authorized, user_settings } = use_slice_user(['is_authorized', 'user_settings']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (is_authorized) return; //no need to establish for authorized users
    if (user_settings.regional_language == i18n.language) return; //already established
    if (!CONSTANTS__shared.SUPPORTED_LANGUAGES.includes(i18n.language)) return; //language is not supported

    void FN_USER_SETTINGS__update(user_settings.clone({ regional_language: i18n.language }));
  }, [is_authorized]);

  return <></>;
}
